import { render, staticRenderFns } from "./CodeEdit.vue?vue&type=template&id=5765beb0&scoped=true&"
import script from "./CodeEdit.vue?vue&type=script&lang=ts&"
export * from "./CodeEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CodeEdit.vue?vue&type=style&index=0&id=5765beb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5765beb0",
  null
  
)

export default component.exports